import { DropdownWithLazyLoad } from './DropdownWithLazyLoad';
import {
  DropdownValueInputProps,
  MultiDropdownValueInput,
} from './MultiDropdownValueInput';

export const DropdownValueInput = ({
  value,
  onChange,
  disabled,
  filterDefinition,
  allowMultiple = false,
}: DropdownValueInputProps) => {
  // Helper to format array values for display
  const formatValue = (val: string | string[]): string => {
    if (Array.isArray(val)) {
      return val.join(', ');
    }
    return String(val);
  };

  if (!allowMultiple) {
    return (
      <DropdownWithLazyLoad
        filterDef={filterDefinition}
        currentValue={formatValue(value)}
        onChange={nextValue => onChange(nextValue)}
        disabled={disabled}
      />
    );
  }

  return (
    <MultiDropdownValueInput
      value={value}
      onChange={onChange}
      disabled={disabled}
      filterDefinition={filterDefinition}
      allowMultiple={allowMultiple}
    />
  );
};
